import type { ScrollActionTypes } from '@medly-components/utils';
import { createContext, useContext } from 'react';

type ScrollContextType = {
    ref: React.RefObject<HTMLDivElement>;
    scrollState: {
        scrolledToTop: boolean;
        scrolledToBottom: boolean;
        scrollPosition: number;
    };
    dispatch: React.Dispatch<ScrollActionTypes>;
};

export const defaultValues: ScrollContextType = {
    ref: { current: null },
    scrollState: {
        scrolledToTop: true,
        scrolledToBottom: false,
        scrollPosition: 120
    },
    dispatch: (): void => {}
};

export const ScrollContext = createContext<ScrollContextType>(defaultValues);

export const useScrollContext = () => useContext(ScrollContext);
